import { t as tr } from '@hana/i18n';
import './SoaTab.i18n';
import { useState } from 'react';
import { IconCheck, IconFileText, IconGitMerge, IconHistory, IconPrinter } from '@tabler/icons-react';
import { useToast } from '@hana/ui';
import { SOA, SOA_AGE_LABELS, SOA_NCC } from './soa';
import { f1 } from './view';
import { norm } from './payables';
import s from './supplierPay.module.css';
import t from './soaTab.module.css';

const PER_LABEL = { m: 'tháng 10/2026', q: 'quý 4/2026', y: 'năm 2026' } as const;
const AGE_COLOR = ['var(--d-blue)', 'var(--d-amber)', 'var(--badge)', 'var(--badge)'] as const;

export function SoaTab({ q, per }: { q: string; per: 'm' | 'q' | 'y' }) {
  const toast = useToast();
  const [sel, setSel] = useState<string>('ONE-LINE');
  const d = SOA[sel]!;
  const end = d.open + d.inc - d.paid;
  const rows = q ? d.rows.filter((r) => norm(r.join(' ')).includes(norm(q))) : d.rows;
  const sum = [['Đầu kỳ', f1(d.open), 'tr ₫ · 01/Oct', ''], ['Phát sinh', f1(d.inc), 'tr ₫', ''], ['Đã trả', f1(d.paid), 'tr ₫', s.okc], ['Cuối kỳ', f1(end), 'tr ₫ · phải trả', end > 0 ? s.warn : s.okc]] as const;
  const max = Math.max(...d.age, 1);
  const noWrite = () => toast({ msg: 'Chưa mở ghi ở bản này' });
  return (
    <>
      <div className={t.ncc}>
        {SOA_NCC.map((k) => <button key={k} type="button" aria-pressed={sel === k} onClick={() => setSel(k)}>{k}</button>)}
      </div>
      <div className={t.kpis}>
        {sum.map(([k, v, u, tone]) => (
          <section key={k} className={s.kpi}><div>{k}</div><b className={tone}>{v}</b><div>{u}</div></section>
        ))}
      </div>
      <div className={t.grid}>
        <section className={s.card} aria-label="Chứng từ trong kỳ">
          <div className={`${t.row} ${t.head}`}><span>{tr('soa.1')}</span><span>{tr('soa.2')}</span><span>Job</span><span>{tr('soa.3')}</span><span className={s.r}>{tr('soa.4')}</span><span className={s.r}>{tr('soa.5')}</span><span className={s.r}>{tr('soa.6')}</span></div>
          {rows.map(([dt, id, job, note, inc, paid]) => {
            const left = inc - paid;
            return (
              <div key={id} className={t.row}>
                <span className={s.tx2}>{dt}</span><b className={s.link}>{id}</b><span>{job}</span><span className={`${s.tx2} ${t.note}`}>{note}</span>
                <span className={s.r}>{inc ? f1(inc) : '—'}</span><span className={`${s.r} ${t.ok}`}>{paid ? f1(paid) : '—'}</span>
                <b className={`${s.r} ${left > 0 ? s.warn : ''}`}>{inc ? f1(Math.max(left, 0)) : '—'}</b>
              </div>
            );
          })}
          <div className={s.foot}><span>Triệu ₫ · {sel} · {PER_LABEL[per]}</span><span>Đối chiếu: {d.recon ?? 'chưa gửi đối tác'}</span></div>
        </section>
        <aside className={t.side}>
          <section className={`${s.card} ${t.box}`}>
            <div className={t.bt}><h2>{tr('soa.7')}</h2><button type="button" className={t.mini} onClick={() => toast({ msg: 'Lịch sử thanh toán chưa mở ở bản này' })}><IconHistory size={14} aria-hidden="true" />{tr('soa.8')}</button></div>
            {d.both && (
              <>
                <div className={t.two}>
                  <div><span>{tr('soa.9')}</span><b>{f1(d.both.ar)}</b></div>
                  <div><span>{tr('soa.10')}</span><b>{f1(d.both.ap)}</b></div>
                </div>
                <button type="button" className={t.btn} onClick={noWrite}><IconGitMerge size={16} aria-hidden="true" />{tr('soa.11')}</button>
              </>
            )}
          </section>
          <section className={`${s.card} ${t.box} ${t.ages}`}>
            <h2>{tr('soa.12')}</h2>
            {SOA_AGE_LABELS.map((k, i) => (
              <div key={k} className={t.age}>
                <span>{k}</span>
                <i className={t.track}><i style={{ width: `${Math.round((d.age[i]! / max) * 100)}%`, background: AGE_COLOR[i] }} /></i>
                <b>{f1(d.age[i]!)}</b>
              </div>
            ))}
          </section>
          <section className={`${s.card} ${t.box}`}>
            <h2><IconFileText size={16} aria-hidden="true" />{tr('soa.13')}</h2>
            <div className={t.doc}>{sel === 'CSHT' ? 'DBN2610036501 · Statement of Account tháng 10 · 12 job' : 'Bảng đối chiếu đối tác gửi về trong tháng · duyệt cả tháng một lần'}</div>
            <button type="button" className={t.btn} onClick={noWrite}><IconCheck size={16} aria-hidden="true" />{tr('soa.14')}</button>
            <button type="button" className={t.btn} onClick={() => toast({ msg: `Đang tạo SOA PDF ${sel}` })}><IconPrinter size={16} aria-hidden="true" />In SOA (PDF)</button>
          </section>
        </aside>
      </div>
    </>
  );
}
